import React from 'react';
import Seo from './Seo';
import './AboutUsPage.css'; // 👈 Create this file for matching style

function AboutUsPage() {
  return (
    <div className="about-wrapper">
      <Seo
        path="/about"
        title="About Tudu — The Smart Planner for Tasks, Routines & Deals"
        description="Learn about Tudu, the AI-powered planner that brings your tasks, routines, team to-dos, trips, and local deals together in one place."
      />
      <div className="about-container">
        {/* Hero Section */}
        <div className="about-header">
          <h1>Redefine Your <span className="brand-highlight">Productivity</span></h1>
          <p className="about-subtitle">
            Tudu combines intelligent task management with local insights to keep your life organized and efficient.
          </p>
        </div>

        {/* Features Grid */}
        <div className="features-grid">
          <div className="feature-card">
            <h3>Smart Planning</h3>
            <p>Intelligent algorithms that optimize your daily schedule based on priority and location.</p>
          </div>
          <div className="feature-card">
            <h3>Local Discovery</h3>
            <p>Integrated maps and store locators to help you find what you need, right when you need it.</p>
          </div>
          <div className="feature-card">
            <h3>Seamless Sync</h3>
            <p>Your tasks, everywhere. Sync seamlessly between your mobile device and web dashboard.</p>
          </div>
        </div>

        {/* Mission Section */}
        <div className="mission-section">
          <h2>Our Mission</h2>
          <p>
            We believe productivity shouldn't be complicated. By blending meaningful automation with a simple, intuitive design,
            Tudu empowers you to focus on what actually matters—getting things done.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutUsPage;
